module.exports = __webpack_public_path__ + "src/img/editIcon.fbf4bb90.svg";